/* Reuse native oil guide, sfSparePartsVehicleV1 and sfSparePartsFavoritesV1.
   No checkout, cart, pricing, customer or catalogue mutations. */
(() => {
  'use strict';
  if (window.SenfinecoAppChrome) return;
  const FAVORITES = 'sfSparePartsFavoritesV1', VEHICLE = 'sfSparePartsVehicleV1';
  const ar = document.documentElement.lang.startsWith('ar');
  const txt = (a, e) => ar ? a : e;
  const $ = (s, root = document) => root.querySelector(s);
  let memory, memoryOnly = false, favoriteLimit = 12, favoriteRun = 0, lastOpener = null;
  const bound = new WeakSet(), oilBound = new WeakSet();
  const productCache = new Map();
  const header = () => $('[data-sf26-app-header]');
  const rootPath = () => (header()?.dataset.root || window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  const status = message => {
    const el = $('[data-sf26-app-status]');
    if (el) { el.textContent = message || ''; el.hidden = !message; }
  };
  function read(key, fallback) {
    if (key === FAVORITES && memoryOnly) return memory || fallback;
    try { return JSON.parse(localStorage.getItem(key) || 'null') ?? fallback; }
    catch (_) { return key === FAVORITES && memory ? memory : fallback; }
  }
  function favorites() {
    const values = read(FAVORITES, []);
    return Array.isArray(values) ? values.filter(v => typeof v === 'string') : [];
  }
  function saveFavorites(values) {
    memory = values;
    try { localStorage.setItem(FAVORITES, JSON.stringify(values)); return true; }
    catch (_) { memoryOnly = true; status(txt('تعذر الحفظ على الجهاز؛ المفضلة متاحة لهذه الزيارة فقط.', 'Device storage is unavailable; favorites last for this visit only.')); return false; }
  }
  function safeURL(value, kind) {
    try {
      const url = new URL(value, location.origin);
      if (url.origin !== location.origin || !/^https?:$/.test(url.protocol)) return null;
      if (kind && !url.pathname.includes('/' + kind + '/')) return null;
      return url;
    } catch (_) { return null; }
  }
  function previewURL(value) {
    const url = safeURL(value); if (!url) return '';
    const current = new URL(location.href);
    ['preview_theme_id', '_fd', 'pb'].forEach(k => { if (current.searchParams.has(k)) url.searchParams.set(k, current.searchParams.get(k)); });
    return url.pathname + url.search + url.hash;
  }
  function handleOf(value) {
    if (typeof value !== 'string' || !value.trim()) return '';
    try {
      if (/[/?:#]/.test(value)) {
        const url = safeURL(value, 'products'); if (!url) return '';
        return decodeURIComponent(url.pathname.split('/products/')[1].split('/')[0]);
      }
      return value.trim();
    } catch (_) { return ''; }
  }
  function entries() {
    const set = new Map();
    favorites().forEach(raw => { const h = handleOf(raw); if (h && !set.has(h)) set.set(h, {raw, handle:h}); });
    return [...set.values()];
  }
  function syncFavorites() {
    const records = entries(), handles = new Set(records.map(v => v.handle));
    document.querySelectorAll('[data-sf26-favorite-count]').forEach(el => { el.hidden = !records.length; el.textContent = records.length > 99 ? '99+' : String(records.length); });
    document.querySelectorAll('[data-sf26-fav-toggle],[data-sf-parts-favorite]').forEach(button => {
      const h = button.dataset.sf26FavToggle || handleOf(button.dataset.sfPartsFavorite);
      const pressed = handles.has(h);
      button.setAttribute('aria-pressed', String(pressed));
      button.setAttribute('aria-label', pressed ? txt('إزالة من المفضلة','Remove from favorites') : txt('أضف إلى المفضلة','Add to favorites'));
      const label = $('[data-sf26-save-label]', button);
      if (label) label.textContent = pressed ? txt('محفوظ في المفضلة','Saved to favorites') : txt('حفظ في المفضلة','Save to favorites');
    });
  }
  function toggleFavorite(handle, removeOnly = false) {
    const list = favorites(), exists = list.some(v => handleOf(v) === handle);
    const next = list.filter(v => handleOf(v) !== handle);
    if (!exists && !removeOnly) next.push(handle);
    saveFavorites(next); syncFavorites();
  }
  function openPanel(id, opener) {
    const panel = document.getElementById(id); if (!panel || typeof panel.showModal !== 'function') return false;
    document.querySelectorAll('.sf26-app-panel[open]').forEach(p => p.close());
    lastOpener = opener;
    panel.showModal();
    document.body.dataset.sf26PanelOpen = id;
    if (!bound.has(panel)) {
      bound.add(panel);
      panel.addEventListener('close', () => {
        if (!document.querySelector('.sf26-app-panel[open]')) document.body.removeAttribute('data-sf26-panel-open');
        favoriteRun++;
        if (lastOpener?.isConnected) lastOpener.focus({preventScroll:true});
      });
      panel.addEventListener('click', event => { if (event.target === panel) { const r=panel.getBoundingClientRect(); if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom) panel.close(); } });
    }
    $('[data-sf26-app-close]', panel)?.focus({preventScroll:true});
    return true;
  }
  function imageURL(value) {
    try { const u = new URL(value, location.origin); return u.protocol === 'https:' && (u.origin === location.origin || u.hostname === 'cdn.shopify.com') ? u.href : ''; }
    catch (_) { return ''; }
  }
  async function fetchProduct(handle) {
    if (productCache.has(handle)) return productCache.get(handle);
    const controller = new AbortController(), timeout = setTimeout(() => controller.abort(), 10000);
    try {
      const r = await fetch(rootPath() + 'products/' + encodeURIComponent(handle) + '.js', {credentials:'same-origin', signal:controller.signal});
      if (!r.ok) throw new Error('product');
      const p = await r.json(); if (!p?.title) throw new Error('product data');
      productCache.set(handle, p); return p;
    } finally { clearTimeout(timeout); }
  }
  function favoriteRow(record) {
    const row = document.createElement('div'); row.className = 'sf26-app-fav-row';
    const a = document.createElement('a'); a.href = previewURL(rootPath() + 'products/' + encodeURIComponent(record.handle));
    const img = document.createElement('img'); img.alt=''; img.width=48;img.height=48;img.hidden=true;
    const name = document.createElement('span'); name.textContent=txt('جارٍ تحميل المنتج…','Loading product…');
    a.append(img,name);
    const remove = document.createElement('button');remove.type='button';remove.textContent='×';remove.dataset.sf26FavRemove=record.handle;remove.setAttribute('aria-label',txt('إزالة من المفضلة','Remove from favorites'));
    row.append(a,remove);return {row,name,img,a,remove};
  }
  async function renderFavorites() {
    const panel = $('#Sf26AppFavorites'); if(!panel?.open)return;
    const run = ++favoriteRun, list = $('[data-sf26-fav-list]',panel), note=$('[data-sf26-fav-status]',panel);
    const records=entries(), chosen=records.slice(0,favoriteLimit);
    list.replaceChildren(); note.textContent = records.length ? '' : txt('لا توجد منتجات محفوظة بعد. اضغط القلب في صفحة المنتج لحفظه هنا.','No saved products yet. Use the heart on a product page to save it here.');
    $('[data-sf26-fav-more]',panel).hidden=records.length<=favoriteLimit;
    const rows=chosen.map(record=>{const item=favoriteRow(record);list.append(item.row);return {record,...item};});
    let cursor=0;
    async function worker(){
      while(cursor<rows.length && run===favoriteRun){
        const row=rows[cursor++];
        try{
          const p=await fetchProduct(row.record.handle); if(run!==favoriteRun)return;
          row.name.textContent=p.title;row.remove.setAttribute('aria-label',txt('إزالة ','Remove ')+p.title);
          const src=imageURL(p.featured_image || p.images?.[0]);if(src){row.img.src=src;row.img.hidden=false;}
        }catch(_){if(run===favoriteRun)row.name.textContent=txt('تعذر تحميل المنتج — افتح الصفحة','Product could not load — open page')+' · '+row.record.handle;}
      }
    }
    await Promise.all(Array.from({length:Math.min(4,rows.length)},worker));
  }
  function vehicle() {
    const v=read(VEHICLE,null);
    return v && typeof v==='object' && !Array.isArray(v) && (v.version===1||v.version===2) && typeof v.label==='string' ? v : null;
  }
  function partsTarget(v) {
    const fallback=header()?.dataset.partsUrl || rootPath()+'collections/all?view=senfineco-spare-parts';
    let url=safeURL(v?.resultsUrl,'collections');
    if (url) {
      let path='';try{path=decodeURIComponent(url.pathname);}catch(_){}
      if(!/-(?:esi|esr)\d+(?:\/|$)/i.test(path)) url=null;
    }
    url ||= safeURL(fallback);
    if(!url)return fallback;
    url.searchParams.set('view','senfineco-spare-parts');
    url.searchParams.delete('page');url.searchParams.delete('section_id');
    const h=new URLSearchParams();
    if(v)['brand','model','year','engine'].forEach((key,i)=>{const value=v.values?.[i] || v[i===0?'make':key];if(typeof value==='string' && value)h.set(key,value);});
    url.hash=h.toString();return previewURL(window.SenfinecoLocaleURL ? window.SenfinecoLocaleURL(url.href).href : url.href);
  }
  function renderCar() {
    const panel=$('#Sf26AppCar'), v=vehicle();if(!panel)return;
    $('[data-sf26-car-label]',panel).textContent=v?v.label:txt('لم تختر سيارة بعد','No vehicle selected');
    const facts=$('[data-sf26-car-facts]',panel);facts.replaceChildren();facts.hidden=!v;
    if(v)['make','model','year','engine'].forEach((key,i)=>{const val=v[key]||v.values?.[i];if(!val)return;const div=document.createElement('div'),dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=(ar?['الماركة','الموديل','السنة','المحرك']:['Make','Model','Year','Engine'])[i];dd.textContent=String(val);div.append(dt,dd);facts.append(div);});
    $('[data-sf26-car-note]',panel).textContent=v?txt('السيارة المحفوظة من اختيارك في المتجر.','The vehicle saved from your store selection.'):txt('اختر الماركة والموديل والسنة والمحرك لعرض قطع الغيار المناسبة.','Choose the make, model, year and engine to find matching parts.');
    const link=$('[data-sf26-car-results]',panel);link.href=partsTarget(v);link.textContent=v?txt('عرض القطع المناسبة','View matching parts'):txt('اختر سيارتك','Choose your vehicle');
    $('[data-sf26-change-car]',panel).hidden=!v;
  }
  function changeCar() {
    // Only an explicit Change vehicle click clears the current selection.
    try {
      localStorage.removeItem(VEHICLE);
      ['sfSparePartsSavedRestoreV2','sfBrandFirstMakeV1','sfBrandFirstFreshIntentV1','sfBrandFirstRouteV1'].forEach(k=>sessionStorage.removeItem(k));
    }catch(_){status(txt('تعذر تغيير السيارة المحفوظة على هذا الجهاز.','The saved vehicle could not be changed on this device.'));return;}
    document.dispatchEvent(new CustomEvent('sf:parts-vehicle-change',{detail:null}));
    location.assign(partsTarget(null));
  }
  function bindOil() {
    const root=$('[data-sf-oil-finder]'); if(!root || oilBound.has(root))return;
    const button=$('[data-sf-oil-open]',root), panel=$('[data-sf-oil-dialog]',root);if(!button||!panel)return;
    oilBound.add(root);
    const proxy=()=>document.querySelectorAll('[data-sf26-app-oil]');
    proxy().forEach(el=>el.setAttribute('aria-controls',panel.id));
    let seenOpen=false;
    new MutationObserver(()=>{
      const open=!panel.hidden;
      proxy().forEach(el=>{el.setAttribute('aria-expanded',String(open));if(open)el.removeAttribute('aria-busy');});
      if(open){seenOpen=true;status('');}
      else if(seenOpen){seenOpen=false;requestAnimationFrame(()=>$('.sf26-app-guide')?.focus({preventScroll:true}));}
    }).observe(panel,{attributes:true,attributeFilter:['hidden']});
    new MutationObserver(()=>{proxy().forEach(el=>{if(button.hasAttribute('aria-busy'))el.setAttribute('aria-busy','true');else el.removeAttribute('aria-busy');});}).observe(button,{attributes:true,attributeFilter:['aria-busy']});
    const message=$('[data-sf-oil-status]',root);
    if(message)new MutationObserver(()=>{if(message.dataset.tone==='notice' && panel.hidden && /تعذر|تعذّر|could not load/i.test(message.textContent))status(message.textContent);}).observe(message,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['data-tone']});
  }
  function openOil(event, opener) {
    const button=$('[data-sf-oil-finder] [data-sf-oil-open]'); if(!button)return;
    event?.preventDefault();
    if(button.getAttribute('aria-busy')==='true')return;
    status('');bindOil();button.click();
  }
  function productSaveButton() {
    const data=$('[data-sf26-app-product]');if(!data)return;
    let p;try{p=JSON.parse(data.textContent);}catch(_){return;}
    if(!p?.handle)return;
    productCache.set(p.handle,{title:p.title,featured_image:p.image});
    const title=$('.template-product #MainContent .sf-product-heading h1') || $('.template-product #MainContent h1');
    if(!title || $('[data-sf26-fav-toggle]'))return;
    const button=document.createElement('button');button.type='button';button.className='sf26-app-save';button.dataset.sf26FavToggle=p.handle;
    const icon=$('.sf26-app-heart svg')?.cloneNode(true),label=document.createElement('span');label.dataset.sf26SaveLabel='';
    if(icon)button.append(icon);button.append(label);title.insertAdjacentElement('afterend',button);syncFavorites();
  }
  function bindSearch() {
    const form=$('[data-sf26-app-search]');if(!form||bound.has(form))return;bound.add(form);
    const input=$('[data-sf26-app-query]',form),panel=$('#Sf26AppSuggestions'), results=$('[data-sf26-app-results]',panel);
    let timer=0,controller,request=0;
    const close=()=>{panel.hidden=true;input.setAttribute('aria-expanded','false');};
    const supported=()=>{try{const f=$('#shopify-features');return !f || JSON.parse(f.textContent).predictiveSearch!==false;}catch(_){return true;}};
    input.addEventListener('input',()=>{
      clearTimeout(timer);controller?.abort();const id=++request,q=input.value.trim();close();
      if(q.length<2||!supported())return;
      timer=setTimeout(async()=>{
        controller=new AbortController();
        try{
          const url=safeURL((header()?.dataset.suggestUrl || rootPath()+'search/suggest')+'.json');
          url.searchParams.set('q',q);url.searchParams.set('resources[type]','product');url.searchParams.set('resources[limit]','4');url.searchParams.set('resources[options][fields]','title,product_type,variants.title,vendor,variants.sku');
          const r=await fetch(url,{credentials:'same-origin',signal:controller.signal});if(!r.ok)throw new Error('search');
          const data=await r.json();if(id!==request||input.value.trim()!==q)return;
          results.replaceChildren();
          (data.resources?.results?.products || []).forEach(p=>{const u=safeURL(p.url,'products');if(!u)return;const a=document.createElement('a');a.href=previewURL(u.href);const src=imageURL(p.featured_image?.url||p.image);if(src){const img=document.createElement('img');img.src=src;img.alt='';img.width=40;img.height=40;a.append(img);}const text=document.createElement('span');text.textContent=p.title;a.append(text);results.append(a);});
          if(results.children.length && document.activeElement===input){panel.hidden=false;input.setAttribute('aria-expanded','true');}
        }catch(_){close();}
      },200);
    });
    input.addEventListener('keydown',e=>{if(e.key==='Escape'){close();return;}if(e.key==='ArrowDown'&&!panel.hidden){e.preventDefault();$('a',results)?.focus();}});
    panel.addEventListener('keydown',e=>{if(e.key==='Escape'){close();input.focus();}});
    document.addEventListener('click',e=>{if(!form.parentElement.contains(e.target))close();});
    form.addEventListener('submit',()=>{close();const id=new URL(location.href).searchParams.get('preview_theme_id');if(id&&!$('input[name=preview_theme_id]',form)){const x=document.createElement('input');x.type='hidden';x.name='preview_theme_id';x.value=id;form.append(x);}});
  }
  function navState(){
    if(!document.body.classList.contains('template-index'))return;
    const isCategories=location.hash==='#sf5-categories'||[...document.querySelectorAll('[data-sf26-tab]')].some(a=>a.hash===location.hash);
    document.querySelectorAll('[data-sf26-app-nav]').forEach(a=>{const active=isCategories?a.dataset.sf26AppNav==='categories':a.dataset.sf26AppNav==='home';if(active)a.setAttribute('aria-current','page');else a.removeAttribute('aria-current');});
  }
  function refresh(){bindOil();bindSearch();productSaveButton();syncFavorites();navState();}
  function start(){
    refresh();
    document.addEventListener('click',event=>{
      if(event.defaultPrevented || event.button>0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)return;
      const trigger=event.target.closest('[data-sf26-app-oil],[data-sf26-app-car],[data-sf26-app-favorites],[data-sf26-app-close],[data-sf26-change-car],[data-sf26-fav-toggle],[data-sf26-fav-remove],[data-sf26-fav-more]');
      if(!trigger)return;
      if(trigger.hasAttribute('data-sf26-app-oil'))return openOil(event,trigger);
      if(trigger.hasAttribute('data-sf26-app-car')){renderCar();if(openPanel('Sf26AppCar',trigger))event.preventDefault();return;}
      if(trigger.hasAttribute('data-sf26-app-favorites')){if(openPanel('Sf26AppFavorites',trigger)){favoriteLimit=12;renderFavorites();}return;}
      if(trigger.hasAttribute('data-sf26-app-close')){trigger.closest('dialog')?.close();return;}
      if(trigger.hasAttribute('data-sf26-change-car'))return changeCar();
      if(trigger.hasAttribute('data-sf26-fav-toggle'))return toggleFavorite(trigger.dataset.sf26FavToggle);
      if(trigger.hasAttribute('data-sf26-fav-remove')){toggleFavorite(trigger.dataset.sf26FavRemove,true);renderFavorites();return;}
      if(trigger.hasAttribute('data-sf26-fav-more')){favoriteLimit+=12;renderFavorites();}
    });
    // Existing parts-card favorites handle their own persistence in a capture listener.
    document.addEventListener('click',event=>{if(event.target.closest('[data-sf-parts-favorite]'))setTimeout(syncFavorites,0);},true);
    document.addEventListener('sf:parts-vehicle-change',renderCar);
    document.addEventListener('shopify:section:load',refresh);
    addEventListener('storage',e=>{if(e.key===FAVORITES){syncFavorites();if($('#Sf26AppFavorites')?.open)renderFavorites();}if(e.key===VEHICLE)renderCar();});
    addEventListener('pageshow',refresh);addEventListener('hashchange',navState);
    if(new URL(location.href).searchParams.get('sf26_oil')==='1')openOil(null,$('.sf26-app-guide'));
  }
  window.SenfinecoAppChrome={version:'1.5.0',refresh};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
